module.exports = __webpack_public_path__ + "static/img/banner-news.082de4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/images/banner-news.jpg
// module id = cUrB
// module chunks = 0